import ListGroup from "react-bootstrap/ListGroup";
import SidebarItem, { type SidebarItemProps } from "./SidebarItem";

type SidebarMenuProps = {
  isMenuOpen?: boolean;
  menuItems: SidebarItemProps[];
};

export default function SidebarMenu({
  isMenuOpen = true,
  menuItems,
}: SidebarMenuProps) {
  return (
    <ListGroup id="sidebarMenu" className={isMenuOpen ? "" : "d-none"}>
      {menuItems.map((item) => (
        <SidebarItem key={(item.linkTo ?? "") + item.text} {...item} />
      ))}
    </ListGroup>
  );
}
